import { Trans } from '@common/i18n/trans';
import { useFormContext } from 'react-hook-form';
import { FormChipField } from '@common/ui/forms/input-field/chip-field/form-chip-field';
import { Item } from '@common/ui/forms/listbox/item';
import { useTrans } from '@common/i18n/use-trans';
import { Checkbox } from '@common/ui/forms/toggle/checkbox';
import { Button } from '@common/ui/buttons/button';
// import { useRemoveItemUwCondtion } from './requests/use-remove-item-uw-my-loan';
import { DeleteIcon } from '@common/icons/material/Delete';
// import { useRemoveFileItemUwCondtion } from './requests/use-remove-file-item-uw-my-loan';
import { useAuth } from '@common/auth/use-auth';
import { ViewOriginal } from '@app_modules/document-requests/reports/document-report-documents-sideleft';
import { useRemoveFileItemUwCondtion } from '@app_modules/loan-applications/step5/requests/use-remove-file-item-uw-my-loan';
import { useRemoveSource } from './requests/use-remove-source';

export interface FileItem {
  file_id: number;
  name: string;
  filename: string;
  check: boolean;
  loan_program_types: string[];
  data: any[];
  status: string;
  md_data: any[];
  loan_program?: string;
}

interface RowFileNameProps {
  report_id: string|number;
  index: number;
  file_item: FileItem;
  selectedFileIds: number[];
  setSelectedFileIds: (names: number[]) => void;
  removeFile: any;
}

export function RowFileItem({
  report_id,
  index,
  file_item,
  selectedFileIds,
  setSelectedFileIds,
  removeFile
}: RowFileNameProps) {
  const { trans } = useTrans();
  const { register, watch, setValue } = useFormContext<any>();
  const file_id = file_item['file_id'];
  const isChecked = selectedFileIds.includes(file_id); // Only use selectedFileIds
  const {user} = useAuth();
  const user_id = user?.id;

  const handleCheckboxChange = (checked: boolean) => {
    if (checked) {
      setSelectedFileIds([...selectedFileIds, file_id]);
    } else {
      setSelectedFileIds(selectedFileIds.filter((name) => name !== file_id));
    }
  };

  const fileId = file_item?.file_id;

  const removeSource = useRemoveSource(report_id, fileId!);

  return (
    <>
    <tr className='w-full border-b'>
      <td className='w-[80%] text-sm text-gray-900 px-6 py-4 whitespace-nowrap'>
        <div className="flex items-center py-10 ">
          
        {file_item.loan_program ? file_item.loan_program : (file_item.name ? file_item.name : file_item.filename)} 
            {file_item.file_id && (user_id == 1 || user_id == 35) ? (<>
              <ViewOriginal file_id={file_item.file_id} />
            </>):(<></>)}
            
        </div>
      </td>
      <td className="w-[10%] px-6 py-4 text-center align-middle">
        <span className="inline-block translate-y-[1px]">
        <Checkbox
            size='md'
            checked={isChecked}
            name={`file-${index}`}
            onChange={(e) => handleCheckboxChange(e.target.checked)}
          >
          </Checkbox>
        </span>
      </td>
      <td className='w-[10%] text-sm text-gray-900 px-6 py-0 whitespace-nowrap'>
      <Button
        size={'xs'}
        variant="outline"
        color="red"
        onClick={() => {
          removeFile(fileId);
          if (report_id && fileId) {
            removeSource.mutate(
              { report_id: report_id, file_id: fileId},
              {
                onSuccess: (response) => {
                  // Handle success if needed
                },
              }
            );
          }
        }}
        disabled={removeSource.isPending}
      >
        <DeleteIcon />
      </Button>
      </td>
      
    </tr>
  </>
    
  );
}